// To contain selectors for state that don't belong to feature modules
import { createSelector } from "reselect";
import { RouterState } from "react-router-redux";

import { RootState, FormsSubstate } from "./types";

export const routing = (state: RootState): RouterState => state.routing;
export const form = (state: RootState): FormsSubstate => state.form;
export const location = createSelector(routing, state => state.location);



// WEBPACK FOOTER //
// ./src/store/selectors.ts